var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoZkcandy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 941.53 221.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "16.14 0 16.14 31.02 82.06 31.02 12.26 124.07 140.2 124.07 140.2 69.8 109.19 69.8 109.19 93.06 74.29 93.06 144.08 0 16.14 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "281.97 0 236.33 0 182.29 42.44 182.29 0 151.28 0 151.28 124.07 182.29 124.07 182.29 81.68 235.95 124.07 282.39 124.07 207.74 63.42 281.97 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "290.67 124.07 414.74 124.07 414.74 93.06 321.68 93.06 321.68 31.02 414.74 31.02 414.74 0 290.67 0 290.67 124.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "649.91 75.81 585.79 0 556.85 0 556.85 124.07 587.87 124.07 587.87 50.57 652.02 124.07 680.93 124.07 680.93 0 649.91 0 649.91 75.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M692.57,0v124.07s98.54,0,98.54,0l25.53-25.53V25.54S791.11,0,791.11,0h-98.54ZM723.6,93.06V31.02s52.57,0,52.57,0l9.47,10.36v42.31s-9.37,9.37-9.37,9.37h-52.67Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "903.56 0 876.12 37.95 849.02 0 810.71 0 860.6 74.85 860.6 124.07 891.61 124.07 891.61 74.85 941.5 0 903.56 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "470.68 0 421.05 124.07 455.97 124.07 484.93 49.49 501.82 93.06 481.06 93.06 481.06 124.07 548.82 124.07 499.2 0 470.68 0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.98,203.81h-6.32v-29.84h31.58v17.91h-25.26v11.94ZM37.93,185.91v-5.97h-18.95v5.97h18.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.34,173.97v29.84h-31.58v-29.84h31.58ZM76.08,179.94v17.91h18.95v-17.91h-18.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.17,173.97v23.87h6.32v-23.87h6.32v23.87h6.32v-23.87h6.32v29.84h-31.58v-29.84h6.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190.27,185.91h18.95v5.97h-18.95v5.97h25.26v5.97h-31.58v-29.84h31.58v5.97h-25.26v5.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M253.68,191.88h-6.32v11.94h-6.32v-29.84h31.58v17.91h-11.15l11.15,11.94h-7.8l-11.15-11.94ZM247.37,179.94v5.97h18.95v-5.97h-18.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.47,185.91h18.95v5.97h-18.95v5.97h25.26v5.97h-31.58v-29.84h31.58v5.97h-25.26v5.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M355.25,203.81v-29.84h25.26l6.32,5.97v17.91l-6.32,5.97h-25.26ZM361.56,197.85h15.79l3.16-2.98v-11.66l-3.16-3.26h-15.79v17.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M490.91,173.97v29.84h-31.58v-29.84h31.58ZM484.6,179.94h-18.95v17.91h18.95v-5.97h-12.63v-5.97h12.63v-5.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M529.06,203.81v-11.94l-12.63-17.91h7.9l7.89,10.44,7.99-10.44h7.8l-12.63,17.91v11.94h-6.32Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M599.78,185.69l25.34-25.34v12.67h25.34l-25.34,19.01v19.01l-25.34-25.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M688.48,185.69l-25.34,25.34v-12.67h-25.34l25.34-19.01v-19.01l25.34,25.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M737.74,207.94v-44.35h10.72v18.75h.58l14.66-18.75h12.63l-15.72,19.79,16,24.56h-12.82l-11.04-17.43-4.29,5.41v12.02h-10.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M699.73,207.94v-6.11l21.55-29.54h-21.53v-8.71h35.08v6.11l-21.55,29.54h21.53v8.71h-35.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M878.84,208.64c-2.97,0-5.57-.74-7.77-2.23-2.19-1.49-3.9-3.52-5.11-6.11-1.21-2.58-1.82-5.53-1.82-8.84s.61-6.3,1.84-8.9c1.24-2.6,2.96-4.63,5.15-6.11,2.19-1.49,4.74-2.23,7.64-2.23,2.22,0,4.24.43,6.04,1.3,1.8.85,3.29,2.06,4.46,3.62,1.18,1.54,1.93,3.35,2.23,5.41h-3.9c-.4-1.88-1.38-3.48-2.92-4.81-1.53-1.34-3.48-2.01-5.85-2.01-2.12,0-4,.58-5.63,1.73-1.63,1.14-2.91,2.74-3.83,4.79-.91,2.04-1.36,4.4-1.36,7.08s.45,5.09,1.34,7.17c.89,2.06,2.15,3.68,3.77,4.85,1.63,1.17,3.54,1.75,5.72,1.75,1.47,0,2.82-.27,4.03-.82,1.23-.56,2.25-1.36,3.07-2.38.84-1.03,1.4-2.24,1.69-3.66h3.9c-.29,2.01-1,3.8-2.14,5.37-1.13,1.56-2.59,2.79-4.4,3.68-1.79.89-3.84,1.34-6.15,1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M838.66,187.15v20.79h-3.85v-33.26h3.75v5.22h.35c.78-1.7,1.99-3.07,3.64-4.09,1.66-1.04,3.71-1.56,6.15-1.56,2.24,0,4.2.47,5.89,1.41,1.7.92,3.02,2.29,3.96,4.09.95,1.8,1.43,4.02,1.43,6.65v21.55h-3.85v-21.31c0-2.73-.77-4.89-2.3-6.47-1.52-1.59-3.55-2.38-6.11-2.38-1.75,0-3.3.38-4.66,1.13-1.36.75-2.43,1.83-3.23,3.25-.78,1.4-1.17,3.07-1.17,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M808.47,220.42c-.77,0-1.48-.07-2.14-.22-.66-.14-1.19-.3-1.58-.48l1.04-3.4c1.31.4,2.48.55,3.51.43,1.02-.1,1.93-.56,2.73-1.39.79-.81,1.5-2.05,2.12-3.72l1.21-3.38-12.24-33.59h4.18l9.87,28.17h.3l9.87-28.17h4.18l-14.08,38.52c-.59,1.6-1.32,2.94-2.19,4.01-.87,1.08-1.87,1.88-3.01,2.4-1.13.53-2.39.8-3.79.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M801.14,181.98l-3.53,1c-.35-1-.84-1.9-1.47-2.71-.64-.81-1.47-1.45-2.49-1.93-1.01-.48-2.27-.71-3.77-.71-2.25,0-4.1.53-5.54,1.6-1.44,1.07-2.17,2.45-2.17,4.14,0,1.43.49,2.59,1.47,3.49,1,.88,2.53,1.58,4.59,2.1l5.02,1.23c2.79.68,4.87,1.75,6.26,3.23,1.4,1.47,2.1,3.32,2.1,5.54,0,1.88-.52,3.54-1.56,5-1.04,1.46-2.49,2.61-4.35,3.44-1.85.82-3.99,1.23-6.43,1.23-3.25,0-5.93-.73-8.03-2.19-2.11-1.47-3.46-3.59-4.05-6.37l3.7-.91c.48,1.98,1.41,3.47,2.79,4.48,1.4,1.01,3.24,1.52,5.52,1.52,2.56,0,4.6-.57,6.13-1.71,1.53-1.15,2.3-2.6,2.3-4.33,0-1.34-.45-2.47-1.34-3.38-.89-.92-2.25-1.6-4.07-2.04l-5.44-1.3c-2.89-.69-5.02-1.79-6.41-3.29-1.39-1.5-2.08-3.36-2.08-5.59,0-1.83.5-3.44,1.49-4.83,1-1.4,2.37-2.5,4.11-3.29s3.74-1.19,5.98-1.19c3.05,0,5.48.69,7.3,2.08,1.83,1.37,3.15,3.26,3.96,5.67Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoZkcandy);
export default __webpack_public_path__ + "static/media/logo-zkcandy.bb166f0d382364400fc1577d235c1922.svg";
export { ForwardRef as ReactComponent };